var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"title":"404: Page Not Found"}},[_vm._v("\n  "+_vm._s(_vm.page_url)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }